import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { Body16 } from 'components/Typography'

export const SortContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SortIcon = styled(Icon)`
  height: 22px;
  width: 22px;
  color: ${theme.colors.horizonOrange};
  :hover {
    opacity: 0.8;
  }
`

export const SortLabel = styled(Body16)`
  color: ${theme.colors.horizonOrange};
  font-weight: 900;
  text-transform: capitalize;
  margin-left: 4px;
`

export const MobileSortWrapper = styled.div`
  margin-bottom: ${theme.spacing.base};
  @media ${theme.devices.tablet} {
    display: none;
  }
`
